import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { ApiError } from "./api/http";
import { router } from "./router";

/** Cuántas veces se reintenta lo que sí puede ser pasajero (un corte de red, un 500). */
export const MAX_RETRIES = 2;

/**
 * Toda lectura pasa por TanStack Query (sección 8.2): los datos se consideran frescos
 * durante 30 s y se vuelven a pedir al regresar a la pestaña del navegador.
 *
 * POR QUÉ NO SE REINTENTA UN 4xx
 *   Un `401`, un `404` o un `400` no cambian por repetirlos: la sesión seguirá caída, el jugador
 *   seguirá sin existir y el filtro seguirá mal escrito. Reintentarlos solo retrasa el aviso —y,
 *   en el caso del `401`, retrasa la vuelta al acceso—. Lo que sí se reintenta es lo que puede ser
 *   un mal momento: un corte de red o un fallo del servidor.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (intentos, error) => {
          if (
            error instanceof ApiError &&
            error.status >= 400 &&
            error.status < 500
          ) {
            return false;
          }
          return intentos < MAX_RETRIES;
        },
      },
    },
  });
}

const queryClient = createQueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* El aviso de React Router sobre v7: se adopta ya para no arrastrar ruido en la consola. */}
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </QueryClientProvider>
  );
}
